export const dashboardRoot = '/dashboard';
export const signInPath = '/sign-in';
export const signUpPath = '/sign-up';
export const profilePath = `${dashboardRoot}/profile`;
export const planSelectionPath = `${dashboardRoot}/plan-selection`;
export const billingPausedPath = `${dashboardRoot}/billing-paused`;
export const startTrialPath = `${dashboardRoot}/start-trial`;
export const maintenance = '/maintenance';
export const downloadCenter = `${dashboardRoot}/download-center`;
export const search = `${dashboardRoot}/search/new`;
export const list = `${dashboardRoot}/list`;
export const crmList = `${dashboardRoot}/list/crm`;
export const signals = `${dashboardRoot}/signals`;
export const techIntelligence = `${dashboardRoot}/tech-intelligence`;
export const signalsMarket = `${signals}/market`;
export const crmAgents = `${dashboardRoot}/agents/crm`;
export const signalAgents = `${dashboardRoot}/agents/signal`;
export const signalAgentCreate = `${signalAgents}/create`;
export const signalsAgentCreate = `${signals}/agent/create`;
export const signalsAgentEdit = `${signals}/agent/edit`;
export const signalsTemplates = `${signals}/templates`;
export const signalsTemplateDetail = (id: string) => `${signalsTemplates}/${id}`;
export const signalAgentEdit = (id: string) => `${signalAgents}/${id}/edit`;
export const peopleFullView = `${dashboardRoot}/people`;
export const companyFullView = `${dashboardRoot}/company`;
export const dataExchange = `${dashboardRoot}/data-exchange`;
export const upload = `${dataExchange}/upload`;
export const accountIntelligence = `${dashboardRoot}/account-intelligence-config`;
export const contactSales = `https://help.firmable.com/kb-tickets/new`;
export const techIntelligenceRegisterInterest = 'https://firmable.ai/tech-intelligence-register-interest/';
export const techIntelligenceProduct = 'https://firmable.ai/tech-intelligence/';
export const userSupport = 'https://firmable.ai/user-support/';
export const acceptTermsPath = '/accept-terms';
export const developerRoot = '/developer';
export const developerSignUpPath = `${developerRoot}/sign-up`;
export const developerSignInPath = `${developerRoot}/sign-in`;
export const developerOnboardingPath = `${developerRoot}/onboarding`;
export const developerApiPath = `${developerRoot}/api`;
export const developerUsagePath = `${developerRoot}/usage`;
export const developerTeamPath = `${developerRoot}/team`;

export const Routes = {
  dashboardRoot,
  signInPath,
  signUpPath,
  profilePath,
  downloadCenter,
  planSelectionPath,
  billingPausedPath,
  startTrialPath,
  maintenance,
  search,
  list,
  crmList,
  signals,
  techIntelligence,
  signalsMarket,
  signalsAgentCreate,
  signalsAgentEdit,
  signalsTemplates,
  signalsTemplateDetail,
  peopleFullView,
  companyFullView,
  dataExchange,
  upload,
  accountIntelligence,
  contactSales,
  techIntelligenceRegisterInterest,
  techIntelligenceProduct,
  userSupport,
  crmAgents,
  signalAgents,
  signalAgentCreate,
  signalAgentEdit,
  acceptTermsPath,
  developerRoot,
  developerSignUpPath,
  developerSignInPath,
  developerOnboardingPath,
  developerApiPath,
  developerUsagePath,
  developerTeamPath,
};
